import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { CookiesService } from 'src/app/services/cookies.service';

@Component({
  selector: 'app-cookies-configurator',
  templateUrl: './cookies-configurator.component.html',
  styleUrls: ['./cookies-configurator.component.scss'],
})
export class CookiesConfiguratorComponent implements OnInit {
  constructor(private fb: FormBuilder, public cookiesService: CookiesService, public cookiesServ: CookieService) {}

  cookies: FormGroup;

  ngOnInit() {
    this.cookies = this.fb.group({
      technical: [true],
      preferences: [false],
      analytics: [false],
      ads: [false],
    });

    //const preferences = JSON.parse(localStorage.getItem('[Merlin] cookies'));
    const cookiesSaved = this.cookiesServ.check('merlin_cookies');

    if (cookiesSaved) {
      const preferences = JSON.parse(this.cookiesServ.get('merlin_cookies'));
      this.cookies.patchValue(this.convertPreferencesToBoolean(preferences));
    }
  }

  convertPreferencesToBoolean(value) {
    const binary = `${this.cookiesService.NumberToBinary(value)}`;
    const result = {
      technical: binary[0] === '1' ? true : false,
      preferences: binary[1] === '1' ? false : false,
      analytics: binary[2] === '1' ? true : false,
      ads: binary[3] === '1' ? true : false,
    };
    return result;
  }

  saveAll() {
    this.cookies = this.fb.group({
      technical: true,
      preferences: false,
      analytics: true,
      ads: true,
    });
    this.cookiesService.acceptAll();
  }

  rejectAll() {
    this.cookies = this.fb.group({
      technical: true,
      preferences: false,
      analytics: false,
      ads: false,
    });
    this.cookiesService.rejectAll();
  }

  saveCookiesSettings() {
    this.cookiesService.saveCookiesSettings(this.cookies.value);
  }
}
